import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { HAS_MORE, PAGE_OFFSET, LAST_APPLIED_UPDATE_TIMESTAMP, MEMBERS, TOTAL_COUNT, OFFSET_TIMESTAMP, OFFSET_ID } from './ViewMembersPage';
export const getHasMore = get(HAS_MORE);
export const getOffset = get(PAGE_OFFSET);
export const getOffsetId = threadListMembersPage => getIn(OFFSET_ID, threadListMembersPage);
export const getOffsetTimestamp = threadListMembersPage => getIn(OFFSET_TIMESTAMP, threadListMembersPage);
export const getMembers = get(MEMBERS);
export const getTotalCount = get(TOTAL_COUNT);
export const getLastAppliedUpdateTimestamp = get(LAST_APPLIED_UPDATE_TIMESTAMP);